import React, { useEffect, useContext, useState } from "react"
import { UserContext } from "../../../../../../context/UserContext.jsx"
import { Stack, Typography } from "@mui/material"
import { Field } from "formik"
import { FormContainer, NavButtons } from "../../../../Menu/Flow"
import { ClassesTable } from "../components"
import employerFlowStyles from "../../styles"
import { FlowHandlersContext } from "../../../../Menu/FlowContainer"

export default function Classes(props) {
    const handlers = useContext(FlowHandlersContext)
    const { mode, exitUrl, step, formik, employerPlanId } = props
    const { getEmployerPlan } = useContext(UserContext)
    const { errors, touched, setFieldValue } = formik
    const [isNavigating, setIsNavigating] = useState(false)
    const [frozenClassCount, setFrozenClassCount] = useState(null)

    
    const employerPlan = getEmployerPlan(employerPlanId)
    const employeeClasses = employerPlan?.permissibleClasses || []
    const planType = employerPlan?.type || ""

    // Freeze the class count when navigating to prevent view changes
    const displayClassCount = isNavigating && frozenClassCount !== null ? frozenClassCount : employeeClasses.length

    // Initialize fields immediately to prevent uncontrolled/controlled warning
    useEffect(() => {
        if (formik.values.classes_required === undefined) {
            setFieldValue("classes_required", "")
        }
        if (formik.values.classes_complete_required === undefined) {
            setFieldValue("classes_complete_required", "")
        }
    }, [])

    useEffect(() => {
        if (!isNavigating) {
            setFieldValue("classes_required", "no")
            if (employeeClasses && employeeClasses.length) {
                setFieldValue("classes_required", "yes")
            }
        }
    }, [employeeClasses?.length, isNavigating])

    useEffect(() => {
        if (!isNavigating) {
            if (employeeClasses && employeeClasses.length > 0) {
                const hasIncompleteClass = employeeClasses.some(employeeClass => employeeClass.isComplete === false)
                if (hasIncompleteClass) {
                    setFieldValue("classes_complete_required", "error")
                } else {
                    setFieldValue("classes_complete_required", "")
                }
            } else {
                setFieldValue("classes_complete_required", "")
            }
        }
    }, [employeeClasses, setFieldValue, isNavigating])

    const handleStartNavigating = () => {
        setFrozenClassCount(employeeClasses.length)
        setIsNavigating(true)
    }

    const handleCancelNavigating = () => {
        setFrozenClassCount(null)
        setIsNavigating(false)
    }
    const handleNextWithoutSubmit = async (event) => {
        event.preventDefault()
        event.stopPropagation()

        // Mark validation fields as touched so errors show
        formik.setFieldTouched("classes_required", true, false)
        formik.setFieldTouched("classes_complete_required", true, false)

        // Validate manually
        const validationErrors = await formik.validateForm()

        if (validationErrors.classes_required || validationErrors.classes_complete_required) {
            return  // stop here — errors will now show
        }

        if (handlers?.onNext) {
            await handlers.onNext()
        }
    }

    return (
        <Stack spacing="30px" height="100%">
            <FormContainer>
                <Typography variant="h2" sx={employerFlowStyles.h2}>Employee Classes</Typography>
                <Typography sx={{ marginBottom: "8px" }}>
                    Define employee classes and set {planType} benefit for each class
                </Typography>
                <Stack spacing={2} sx={{ marginTop: "20px" }}>
                    <ClassesTable
                        {...props}
                        displayClassCount={displayClassCount}
                        onStartNavigating={handleStartNavigating}
                        onCancelNavigating={handleCancelNavigating}
                    />
                    {/* Hidden field for validation */}
                    <Field name="classes_required">
                        {({ field }) => (
                            <input
                                {...field}
                                type="hidden"
                                value={field.value || ""}
                            />
                        )}
                    </Field>
                    {errors.classes_required && touched.classes_required && (
                        <div className="error-message-fields">{errors.classes_required}</div>
                    )}
                    {/* Hidden field for classes completion validation */}
                    <Field name="classes_complete_required">
                        {({ field }) => (
                            <input
                                {...field}
                                type="hidden"
                                value={field.value || ""}
                            />
                        )}
                    </Field>
                    {errors.classes_complete_required && touched.classes_complete_required && (
                        <div className="error-message-fields">{errors.classes_complete_required}</div>
                    )}
                </Stack>
            </FormContainer>
            <NavButtons
                mode={mode}
                exitUrl={exitUrl}
                step={step}
                disabled={isNavigating}
                onNextStep={handleNextWithoutSubmit}
            />
        </Stack>
    )
}